.tableStack {
  min-height: 0;
}

.fixedTableHeadFoot {
  overflow-y: auto;
  min-height: 0;
  > table > thead,
  > table > tfoot {
    position: sticky;
  }
  > table > thead {
    inset-block-start: 0; /* "top" */
  }
  > table > tfoot {
    inset-block-end: 0; /* "bottom" */
  }
}

// Selected-row highlight. Not Bootstrap's `.table-info` — that class is generated once from the
// LIGHT `$info` Sass value and never re-declared under `[data-bs-theme=dark]`, so on any app that
// leaves `$info` at its default, the row's light-mode cyan fill leaks unchanged into dark mode and
// crushes whatever foreground sits on top of it.
//
// A first fix landed on `--bs-tertiary-bg`/`--bs-body-color` — theme-aware, but `--bs-tertiary-bg`
// is a neutral grey nearly identical to the table's own zebra-striping fill, so the row read as
// accessible but no longer as SELECTED: readability was gained and distinguishability was lost.
// `--bs-warning-bg-subtle`/`--bs-warning-text-emphasis` are Bootstrap 5.3's subtle-fill pair —
// re-declared under `[data-bs-theme=dark]` (compiled from `apps/quickscore/admin/src/assets/css/
// bootstrap5.scss`), so still one rule for both modes — but, unlike the neutral tokens, carry a
// warm tint clearly off-hue from the cool-grey stripe, so a selected row reads as distinct from a
// striped or plain one at a glance in both themes, not just under a contrast checker.
// `--bs-warning-text-emphasis` on `--bs-warning-bg-subtle` measures 7.181:1 (light) / 10.845:1
// (dark); this app's ticket-code link (`--bs-link-color`, unstyled `<a>` inside the row) on the
// same fill measures 4.613:1 (light) / 6.442:1 (dark) — `--bs-info-bg-subtle` and
// `--bs-primary-bg-subtle` were tried first and both put that link under 4.5:1 in light mode
// (4.400:1 and 3.937:1).
//
// The fill and text each read from a `--datatable-selected-*` custom property first, falling back
// to the accessible tint above (`--offcanvas-width` in RouteOffCanvas.module.scss is the same
// component-scoped-token-with-fallback shape). An app that never sets these properties gets the
// measured-accessible tint with no action required. An app that DOES set one — to brand-tint its
// selected row — takes over that pairing's contrast obligation: nothing here checks a
// caller-supplied colour against `--bs-table-color`/`--bs-table-border-color`, so re-tinting can
// reintroduce the same defect this fallback exists to fix. Set the properties on the app's own
// stylesheet (e.g. its `bootstrap5.scss`), never here. Border stays on the neutral
// `--bs-border-color` — a row separator, not a fill the selected text sits on, so it carries no
// contrast obligation against `--bs-warning-bg-subtle`.
.selectedRow {
  --bs-table-bg: var(--datatable-selected-bg, var(--bs-warning-bg-subtle));
  --bs-table-striped-bg: var(--datatable-selected-bg, var(--bs-warning-bg-subtle));
  --bs-table-active-bg: var(--datatable-selected-bg, var(--bs-warning-bg-subtle));
  --bs-table-hover-bg: var(--datatable-selected-bg, var(--bs-warning-bg-subtle));
  --bs-table-color: var(--datatable-selected-color, var(--bs-warning-text-emphasis));
  --bs-table-border-color: var(--datatable-selected-border-color, var(--bs-border-color));
}
